import type {
  ApiCarrierCompliance,
  ApiCarrierDetail,
  ApiCarrierDriverRow,
  ApiCarrierEquipmentRow,
} from "api-client";
import { CARRIER_BOOKINGS_SORT_ARRIVAL_UI } from "api-client";
import type { BookingRow } from "design-components";

/** Matches customer list paging (`CUSTOMERS_LIST_PAGE_SIZE`). */
export const CARRIER_DRIVERS_PAGE_SIZE = 50;
export const CARRIER_EQUIPMENT_PAGE_SIZE = 50;

/** Carrier detail Bookings tab page size (AV-210). */
export const CARRIER_BOOKINGS_PAGE_SIZE = 10;

export interface CarrierDriversListState {
  rows: ApiCarrierDriverRow[];
  totalCount: number;
  loading: boolean;
  error: string | null;
  fromIndex: number;
  toIndex: number;
  search: string;
  showOnlyActive: boolean;
  sortField: string;
  sortOrder: "asc" | "desc";
}

export const initialCarrierDriversListState: CarrierDriversListState = {
  rows: [],
  totalCount: 0,
  loading: false,
  error: null,
  fromIndex: 0,
  toIndex: CARRIER_DRIVERS_PAGE_SIZE,
  search: "",
  showOnlyActive: true,
  sortField: "driverName",
  sortOrder: "asc",
};

/** AV-213 Compliance tab — empty when `data` is null or fetch failed. */
export interface CarrierComplianceState {
  data: ApiCarrierCompliance | null;
  loading: boolean;
}

export const initialCarrierComplianceState: CarrierComplianceState = {
  data: null,
  loading: false,
};

export interface CarrierEquipmentListState {
  rows: ApiCarrierEquipmentRow[];
  totalCount: number;
  loading: boolean;
  error: string | null;
  fromIndex: number;
  toIndex: number;
  search: string;
}

export const initialCarrierEquipmentListState: CarrierEquipmentListState = {
  rows: [],
  totalCount: 0,
  loading: false,
  error: null,
  fromIndex: 0,
  toIndex: CARRIER_EQUIPMENT_PAGE_SIZE,
  search: "",
};

export interface CarrierBookingsListState {
  rows: BookingRow[];
  totalCount: number;
  loading: boolean;
  error: string | null;
  search: string;
  statusFilterValues: string[];
  dateFrom: string | null;
  dateTo: string | null;
  fromIndex: number;
  toIndex: number;
  sortingField: string;
  sortingOrder: "asc" | "desc";
}

export const initialCarrierBookingsListState: CarrierBookingsListState = {
  rows: [],
  totalCount: 0,
  loading: false,
  error: null,
  search: "",
  statusFilterValues: [],
  dateFrom: null,
  dateTo: null,
  fromIndex: 0,
  toIndex: CARRIER_BOOKINGS_PAGE_SIZE,
  sortingField: CARRIER_BOOKINGS_SORT_ARRIVAL_UI,
  sortingOrder: "asc",
};

export interface CarrierDetailState {
  carrier: ApiCarrierDetail | null;
  loading: boolean;
  error: string | null;
  selectedCarrierId: string | null;
  driversList: CarrierDriversListState;
  compliance: CarrierComplianceState;
  equipmentList: CarrierEquipmentListState;
  bookingsList: CarrierBookingsListState;
}

export const carrierDetailInitialState: CarrierDetailState = {
  carrier: null,
  loading: false,
  error: null,
  selectedCarrierId: null,
  driversList: { ...initialCarrierDriversListState },
  compliance: { ...initialCarrierComplianceState },
  equipmentList: { ...initialCarrierEquipmentListState },
  bookingsList: { ...initialCarrierBookingsListState },
};
